import React, { useState } from 'react'

export const Footer = () => {

  return (
    <footer className="content">
      <section className="content--standard footer">
        <ul className="footer--linkArea">
          <li><a href="https://www.deltan.co.jp/" rel="noreferrer">運営会社</a></li>
          <li><a href="https://fine-hydrogen-1ac.notion.site/cdce9906eb3a43d69cc7a797cf822041" rel="noreferrer">利用規約</a></li>
          <li><a href="https://hanalove.jp/privacy/" rel="noreferrer">プライバシーポリシー</a></li>
          <li><a href="https://hanalove.secure.force.com/enqueteForm?prm=hanalove" rel="noreferrer">お問い合わせ</a></li>
        </ul>
        <p className="footer__copyright" translate='no'>©Deltan, Inc. All Rights Reserved.</p>
      </section>
    </footer>
  )
}